import { isRestrictedAge } from '../helpers/getAgeInfo';
export function createStageInjectedProxy(target, stage) {
    return new Proxy(target, {
        get(target, prop, _receiver) {
            if (typeof prop !== 'string' || !(prop in target)) {
                return;
            }
            const original = target[prop];
            if (typeof original === 'function') {
                return function (...args) {
                    if (isRestrictedAge() || stage == 'dev') {
                        return new Proxy(target, {
                            get() {
                                return;
                            },
                        });
                    }
                    if (typeof args[0] === 'object' && args[0] !== null) {
                        args[0] = {
                            ...args[0],
                            stage,
                        };
                    }
                    else {
                        args.splice(2, 0, { stage });
                    }
                    return original.apply(target, args);
                };
            }
            return original;
        },
    });
}
